export default __webpack_public_path__ + "static/media/clearNight.8a130ffb.mp4";